export default "__VITE_ASSET__sfyfyay7__"